import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  injectTellentIsOneSettingsEnabled,
  TellentNavigationRoutingService,
} from '@core/tellent-logic';
import {
  AppKind,
  ORG_GUID,
  TellentBrand,
  TellentClientSettingsHomepageID,
} from '@core/tellent-types';
import { injectTellentAppUrlBuilder } from '@core/tellent-util';
import {
  DividerComponent,
  DropdownComponent,
  DropdownItemComponent,
  IconComponent,
  TruncateComponent,
} from '@core/user-interface-legacy';
import { WalkthroughStepOriginDirective } from '@core/walkthrough-ui';

import { TellentAppLogoComponent } from '../../tellent-app-logo/tellent-app-logo.component';
import { TELLENT_APP_SHELL_LAYOUT } from '../../tellent-app-shell/tellent-app-shell-constants';
import { TellentAppSwitcherApps } from '../tellent-app-switcher-next.types';

@Component({
  selector: 'tlc-app-switcher-dropdown',
  templateUrl: './tellent-app-switcher-dropdown.component.html',
  styleUrl: './tellent-app-switcher-dropdown.component.less',
  imports: [
    DropdownComponent,
    DropdownItemComponent,
    IconComponent,
    TellentAppLogoComponent,
    DividerComponent,
    TranslatePipe,
    TruncateComponent,
    WalkthroughStepOriginDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentAppSwitcherDropdownComponent {
  #routingSvc = inject(TellentNavigationRoutingService);

  protected readonly TellentBrand = TellentBrand;
  protected readonly AppKind = AppKind;
  protected readonly TELLENT_APP_SHELL_LAYOUT = TELLENT_APP_SHELL_LAYOUT;
  protected readonly ORG_GUID = inject(ORG_GUID) ?? undefined;

  public readonly isOneSettingsEnabled =
    injectTellentIsOneSettingsEnabled({ optional: true }) ?? false;

  public activeApp = input.required<TellentBrand>();
  public apps = input.required<TellentAppSwitcherApps>();

  public urlBuilder = injectTellentAppUrlBuilder();

  public settingsRoute = computed(() => {
    if (this.isOneSettingsEnabled) {
      const route = this.#routingSvc
        .recognizedRoutes()
        .find(route => route.id === TellentClientSettingsHomepageID);

      if (route) {
        return route.buildPath();
      }
    }

    return this.urlBuilder(
      AppKind.TellentAdmin,
      { id: TellentClientSettingsHomepageID },
      this.ORG_GUID,
    );
  });

  public navigateToSettings(event: MouseEvent, url: string) {
    if (url.startsWith('http')) return;

    if (!event.metaKey) event.preventDefault();
    this.#routingSvc.navigate(url);
  }
}
